// extracted by mini-css-extract-plugin
export default {"group":"TextArea_group__Y7-yl","textarea":"TextArea_textarea__PJfPA","required":"TextArea_required__nLbmP","label":"TextArea_label__9lgKN"};